module.exports = __webpack_public_path__ + "static/media/check.5fdee782.svg";